<template>
  <div class="skill-plan-session-details">
    <ActionLoader v-if="isLoading" class="skill-plan-session-details__loader" />
    <template v-else>
      <div
        v-if="skillDivePlanConsumed.length > 0"
        id="skill-dive-session-item-list"
        class="skill-plan-session-details__list"
      >
        <div v-for="sessionItem in skillDivePlanConsumed" :key="sessionItem.id">
          <SkillDiveSessionItem :sessionItem="sessionItem" />
        </div>
      </div>
      <SkillDivePlanSessionEmpty v-else class="skill-dive-session-empty" />
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import SkillDivePlanSessionEmpty from './SkillDivePlanSessionEmpty.vue'
import SkillDiveSessionItem from './SkillDiveSessionItem.vue'
export default {
  name: 'SkillDivePlanSessionDetails',
  components: { ActionLoader, SkillDivePlanSessionEmpty, SkillDiveSessionItem },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      skillDivePlanConsumed: state => state.subscriptions.skillDivePlanConsumed,
    }),
  },
  async created() {
    this.isLoading = true
    await this.$store.dispatch('subscriptions/getSkillDivePlanConsumed')
    this.isLoading = false
  },
}
</script>
<style lang="scss" scoped>
.skill-plan-session-details {
  display: flex;
  justify-content: center;
  margin: 15px 15px 25px 15px;

  &__loader {
    display: flex;
    justify-content: center;
  }

  &__list {
    width: 100%;
  }
}
</style>
